export default {
  SET_EQUIPMENT_STATUSES: (state, payload) => state.equipmentStatuses = payload,

  SET_EQUIPMENT_STATUS_STATUSES: (state, payload) => {
    state.statuses = payload;
    (payload || []).forEach(s => state.statusesMap[s.id] = s.description);
  }
}